import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { CartRepository } from '@digital-platform/rs-shop/shop-state';

@Injectable({
  providedIn: 'root',
})
export class PersistantCartService {
  public router = inject(Router);
  public returnedToWebsite = true;
  private cartRepository = inject(CartRepository);

  public initialize(): void {
    this.persistCart();
  }

  private persistCart(): void {
    const cartCount = this.cartRepository.cartCount();

    if (this.returnedToWebsite && !this.router.url.startsWith('/shop')) {
      this.returnedToWebsite = false;

      if (cartCount > 0) {
        this.router.navigate(['/shop/api/abandon-cart'], {
          queryParams: { type: 'persistant' },
        });
      }
    }
  }
}
